import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: ${props => (!props.isTextElement && 'center')};
  justify-content: center;
  flex-direction: column;
  padding: ${props =>
    props.actionType && props.actionType === 'replace-template-page'
      ? '5px'
      : props.isFillable
      ? '20px 0'
      : '20px'};
  padding-top: ${props =>props.docElementTab && '0px !important'};
  background: hsla(0, 0%, 100%, 0.07);
  border-radius: 4px;
  transition: background-color 0.15s ease-in-out;
  filter: ${props => (props.type === 'colored' ? `` : 'contrast(0) brightness(10)')};
  .no-thumbnail-info {
    font-size: 10px;
    color: rgb(255 255 255 / 0.45);
    text-align: center;
    margin: 5px;
  }
  &.elementContainer{
    padding:15px !important;
    border-radius: 16px!important;
  }
  p{
    text-transform:uppercase;
    padding-top: 5px;
    font-size: 12px;
    font-weight: 600;  
    user-select: none;
  }
  &:hover {
    background: hsla(0, 0%, 100%, 0.15);
    cursor: pointer;
  }
  @media only screen and (max-width: 1460px){
    p{
      font-size: 12px;
    }
  }
  p.elementName{
    color:hsla(0, 0%, 100%, 70%) !important;
    font-weight: 500;
    position: absolute;
    bottom: 10px; 
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    max-width: ${props => (props.isFillable ? '100%' : '115px')};
    width: ${props => (props.isFillable && '100%')};
    left: ${props => (props.isFillable && '0')};
  }
  .textElement {
    p {
      text-transform: none !important;
      padding: 0 !important;
      user-select: none !important;
    }
    .fillableThumbnail {
      font-size: 15px;
      font-weight: 500;
    }
    .comboBox {
      font-size: 14px;
      margin-right: 16px !important;
      font-weight: 500;
    }
  }
`;

export const Thumbnail = styled.img`
  border-radius:2px;
  width: initial;
  max-height:${props => (props.docElementTab ? '80%' : '100%')};
  height:${props => (props.reusableSection ? '' : props.reusableTemplate && '305px')};
  max-width: 100%;
  &.no-thumbnail {
    display: flex;
    background: #fff;
    align-items: center;
    justify-content: center;
  }
  padding: ${({enablePadding}) => enablePadding && "50px 0 50px 0"}
`;

export const ThumbnailPreview = styled.img`
  position: absolute;
  &.no-thumbnail {
    display: flex;
    max-width: 100px;
    align-items: center;
    justify-content: center;
  }
`;

export const CustomDragContainer = styled.div`
  position: fixed;
  pointer-events: none;
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  
  > div {
    p {
      color: black;
      line-height: normal;
      font-size: inherit;
    }
    p * {
      vertical-align: baseline;
      color: inherit;
      line-height: inherit;
    }
  }
`;

export const LoaderView = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: 50px;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 10000000;
  opacity: 0.4;
`;

export const TemplatePageOverview = styled.div`
  position: relative;
  width: ${props => (props.reusableSection ?'140px' : '225px')};
  height: ${props => (props.reusableSection ? '' : '350px')};
  margin: ${props => (props.reusableSection ? '10px': '20px 0px 0px 0px')};
  background: ${props => (props.reusableSection && 'rgba(255, 255, 255, 0.07)')};
  border-radius: ${props => (props.reusableSection && '8px')};
  transition: transform 0.2s cubic-bezier(0.33, 0.04, 0.63, 0.93) 0s;
  .template-media {
    position: relative;
    padding: 5px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: ${props => (props.reusableSection ? '165px' : '315px')};
    background: ${props => (props.reusableSection ? 'transparent' : '#fff !important')};
    border: none;
    box-shadow:none};
  }
  .template-name {
    font-size: 18px;
    color:#fff;
    padding: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    h2 {
      font-family: ambroise-firmin-std, serif;
      color: #fff;
      font-size: ${props => (props.reusableSection ? '12px' : '18px')} !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre;
      text-align: center;
      max-width: 350px;
    }
  }

  .preview-button {
    background-color: rgba(14, 19, 24, 0.7);
    color: #ffffff;
    width: 22px;
    height: 18px;
    border-radius: 5px;
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 15px;
    right: 10px;
    font-size: 14px;
    .anticon {
      color: #fff;
    }
    &:hover {
      background-color: rgb(0 0 0 / 0.5);
    }
  }
  &:hover {
    cursor: pointer;
    transform: scale(1.05) translate(0px, 0px) perspective(500px);
    .dropdown-menu {
      display: flex;
    }
    .preview-button {
      display: flex;
    }
  }
  .ant-checkbox {
    margin-right: 5px;
  }
  .ant-checkbox,
  .ant-checkbox-inner {
    width: 25px;
    height: 25px;
  }
  .ant-checkbox-inner {
    border: 2px solid white;
    &::after {
      border-color: black !important;
    }
  }
  .ant-checkbox .ant-checkbox-inner {
    background-color: white !important;
    border-color: black !important;
  }
  .no-thumbnail {
    border-radius: 8px !important;
    object-fit: contain;
  }
`;